// 跳转
// 传信息
//
import wx from 'weixin-js-sdk'
import cookie from '@app/js/lib/cookie'
import CONSTANT from '@app/js/constant/cookie'
import {getUrlparam} from '@app/js/util/function'
import { app } from '@app/js/util/platform'
import _ from 'underscore'
import KeyMirror from 'keymirror'


const MESSAGE_TYPE = KeyMirror({
  CASH_PAY: null,
})

const mp = {
  isInMpSdtj: false,
  loginFromMp({xToken, userId}) {
    cookie(CONSTANT.COOKIE_USER_X_TOKEN, xToken)
    cookie(CONSTANT.COOKIE_USER_ID, userId)
  },
  jumpMp(page, payload) {
    let to = page ? wx.miniProgram.navigateTo : wx.miniProgram.navigateBack
    let url = ''
    switch (page) {
      case 'productDetail':
        url = `/pages/item/index?productId=${payload.productId}`
        break;
      case 'cashPay':
        const {
          totalPrice,
          payOrderId,
        } = payload
        url = `/pages/preorder/webview-pay?totalPrice=${totalPrice}&payOrderId=${payOrderId}`
        to = wx.miniProgram.redirectTo
        break;
      case 'home':
        url = `/pages/home/index`
        to = wx.miniProgram.switchTab
        break
      case 'map':
        url = `/pages/agency/map?la=${payload.lat}&lo=${payload.lng}&name=${payload.name}`
        break
      default:
        break;
    }
    to({
      url,
    })
  },
  toPay({totalPrice, payOrderId}) {
    this.jumpMp('cashPay', {
      totalPrice,
      payOrderId,
    })
  },
  postMessage(msgObj) {
    console.log("before send",  JSON.stringify(msgObj))
    wx.miniProgram.postMessage({ data: {...msgObj}})
  },
  routerBeforeEach(routes, to) {
    if(this.isInMpSdtj) {
      let target = _.find(routes, r => {
        return r.name === to.name
      })
      document.title = target.title || ''
    }
  },
  init() {
    let co = getUrlparam('co')
    if(co && co !==  cookie(CONSTANT.COOKIE_CO)) {
      cookie(CONSTANT.COOKIE_CO, co)
    }
    if(app.isMPSdtj()) { // TODO 只是为了方便调试，最后记得删掉
      // 如果是在苏打体检小程序里面 登陆
      this.isInMpSdtj = true
      let mpUserInfo = getUrlparam('ui')
      this.loginFromMp(JSON.parse(mpUserInfo))
    }
  }

}

export default mp
